import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import TMRentTable from "components/tenant-market/rent/tm-rent-table"
// Data
import api_match from "data/interface/api"
import rentService from "data/rent"
import propertyService from 'data/property.ts'
import importService from "data/import"
import inflationService from "data/inflation"
import { alphanum } from "components/table/lib/sort"
//Styles
import { TMRent_s } from "components/tenant-market/rent/tm-rent-styles"
import { AddIcon } from "images/icons/tools"

const TMRent: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const [inflation, setInflation] = useState<object[]>([])
  const tableId = "tm-rent-table"

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const rentSubscription = rentService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          setData(ok.value)
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const property = _.find(data.value, {propertyid: data.current});
        setProperty(property)
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    const inflationSubscription = inflationService.stream().subscribe(data => {
      api_match(
        data,
        init  => setInflation(init.value),
        ok    => {
          setInflation(ok.value)
        },
        err   => {
          setInflation(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    return function cleanup() {
      rentSubscription.unsubscribe()
      propertySubscription.unsubscribe()
      inflationSubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    rentService.fetchRent(propertyId)
    propertyService.fetchProperty(propertyId)
    inflationService.fetchInflation(propertyId)

  }, [propertyId])

  const Add = () => {
    const defaults = property ? {...property['defaultsnameditem']} : {}
    return (
      <a onClick={() => rentService.create(propertyService.getStoredPropertyId(), defaults)}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <TMRent_s>
      <Toolbar>
        <Add />
        <ImportIcon />
        <ExportIcon template="rent" />
      </Toolbar>
      { showImport && <Import /> }
      { data && property && inflation && !showImport &&
      <TMRentTable
        tableId={tableId}
        data={data}
        inflationData={inflation}
        defaults={{...property['defaultsnameditem']}} /> }
    </TMRent_s>
  )
}

export default TMRent
